import { EditPanelContainerComponent } from './components/edit-panel-container/edit-panel-container.component';
import { WorkspaceNodeAttachmentComponent } from './components/workspace/attachment/workspace-node-attachment/workspace-node-attachment.component';
import { WorkspaceRootAttachmentComponent } from './components/workspace/attachment/workspace-root-attachment/workspace-root-attachment.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlueprintEdgePropertyComponent } from './components/blueprint/blueprint-edge-property/blueprint-edge-property.component';
import { BlueprintFieldCheckboxComponent } from './components/blueprint/blueprint-field-property/blueprint-field-checkbox/blueprint-field-checkbox.component';
import { BlueprintFieldDateComponent } from './components/blueprint/blueprint-field-property/blueprint-field-date/blueprint-field-date.component';
import { BlueprintFieldDatetimeComponent } from './components/blueprint/blueprint-field-property/blueprint-field-datetime/blueprint-field-datetime.component';
import { BlueprintFieldDropdownMultipleComponent } from './components/blueprint/blueprint-field-property/blueprint-field-dropdown-multiple/blueprint-field-dropdown-multiple.component';
import { BlueprintFieldDropdownSingleComponent } from './components/blueprint/blueprint-field-property/blueprint-field-dropdown-single/blueprint-field-dropdown-single.component';
import { BlueprintFieldFormattedTextComponent } from './components/blueprint/blueprint-field-property/blueprint-field-formatted-text/blueprint-field-formatted-text.component';
import { BlueprintFieldMemoComponent } from './components/blueprint/blueprint-field-property/blueprint-field-memo/blueprint-field-memo.component';
import { BlueprintFieldNumberComponent } from './components/blueprint/blueprint-field-property/blueprint-field-number/blueprint-field-number.component';
import { BlueprintFieldRadioGroupComponent } from './components/blueprint/blueprint-field-property/blueprint-field-radio-group/blueprint-field-radio-group.component';
import { BlueprintFieldTableComponent } from './components/blueprint/blueprint-field-property/blueprint-field-table/blueprint-field-table.component';
import { BlueprintFieldTextComponent } from './components/blueprint/blueprint-field-property/blueprint-field-text/blueprint-field-text.component';
import { BlueprintFieldUrlComponent } from './components/blueprint/blueprint-field-property/blueprint-field-url/blueprint-field-url.component';
import { BlueprintFieldUserComponent } from './components/blueprint/blueprint-field-property/blueprint-field-user/blueprint-field-user.component';
import { BlueprintNodePropertyComponent } from './components/blueprint/blueprint-node-property/blueprint-node-property.component';
import { BlueprintRootPropertyComponent } from './components/blueprint/blueprint-root-property/blueprint-root-property.component';
import { WorkspaceEdgePropertyComponent } from './components/workspace/workspace-edge-property/workspace-edge-property.component';
import { WorkspaceRootPropertyComponent } from './components/workspace/workspace-root-property/workspace-root-property.component';
import { SHARED_EDIT_PANEL_ROUTES } from './components/blueprint/blueprint-router-constants';

export const sharedEditPanelroutes: Routes = [
  {
    path: SHARED_EDIT_PANEL_ROUTES.WORKSPACE_ROOT_PROPERTY,
    component: WorkspaceRootPropertyComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.WORKSPACE_NODE_PROPERTY}/:id`,
    component: EditPanelContainerComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.WORKSPACE_EDGE_PROPERTY}/:id`,
    component: WorkspaceEdgePropertyComponent,
  },
  {
    path: SHARED_EDIT_PANEL_ROUTES.WORKSPACE_ROOT_ATTACHMENTS,
    component: WorkspaceRootAttachmentComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.WORKSPACE_NODE_ATTACHMENTS}/:id`,
    component: WorkspaceNodeAttachmentComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_CHECKBOX}/:id`,
    component: BlueprintFieldCheckboxComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_DATE}/:id`,
    component: BlueprintFieldDateComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_DATETIME}/:id`,
    component: BlueprintFieldDatetimeComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_DROPDOWN_SINGLE}/:id`,
    component: BlueprintFieldDropdownSingleComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_DROPDOWN_MULTIPLE}/:id`,
    component: BlueprintFieldDropdownMultipleComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_MEMO}/:id`,
    component: BlueprintFieldMemoComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_NUMBER}/:id`,
    component: BlueprintFieldNumberComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_RADIO_GROUP}/:id`,
    component: BlueprintFieldRadioGroupComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_TABLE}/:id`,
    component: BlueprintFieldTableComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_USER}/:id`,
    component: BlueprintFieldUserComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_URL}/:id`,
    component: BlueprintFieldUrlComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_FORMATTED_TEXT}/:id`,
    component: BlueprintFieldFormattedTextComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_FIELD_TEXT}/:id`,
    component: BlueprintFieldTextComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_EDGE_PROPERTY}/:id`,
    component: BlueprintEdgePropertyComponent,
  },
  {
    path: SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_ROOT_PROPERTY,
    component: BlueprintRootPropertyComponent,
  },
  {
    path: `${SHARED_EDIT_PANEL_ROUTES.BLUEPRINT_NODE_PROPERTY}/:id`,
    component: BlueprintNodePropertyComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(sharedEditPanelroutes)],
  exports: [RouterModule],
})
export class SharedEditPanelRoutingModule {}
